import { Routes } from '@angular/router';
import { AppLanguages } from './langs-available';
import { RootTranslationGuard } from './root-translation.guard';

export const buildMultiLanguageRoutesFragment = (
  routes: Routes,
  languages: AppLanguages[] = [AppLanguages.en, AppLanguages.ru],
): Routes => [
  ...languages.map((lang) => ({
    path: lang,
    canActivate: [RootTranslationGuard],
    children: routes,
  })),
  {
    path: '',
    canActivate: [RootTranslationGuard],
    children: routes,
  },
];
